import { createContext, useContext } from 'react'

import type {
  LuggageFilterValue,
  PaymentFilterValue,
  SortFilterValue,
  StopsFilterValue,
} from '@/lib/schemas/flight-results-search.schema'

export interface FiltersStateContextValue {
  filters: FlightFilterParams
  setFilters: (partialFilters: Partial<FlightFilterParams>) => void
}

/**
 * Shared shape of the filter-related URL search params. Both the flight results
 * route and the NLP (vols-multi) route expose these params, so the filter
 * components read/write them through this context instead of binding to a
 * single route id (which would throw a TanStack Router invariant error when
 * mounted on another route).
 */
export interface FlightFilterParams {
  filterAirlines?: string
  filterDurationMax?: number
  filterDurationMin?: number
  filterLuggage?: LuggageFilterValue
  filterPayment?: PaymentFilterValue
  filterPriceMax?: number
  filterPriceMin?: number
  filterSort?: SortFilterValue
  filterStops?: StopsFilterValue
  filterTimeRanges?: string
}

export const FiltersStateContext = createContext<FiltersStateContextValue | null>(null)

export function useFiltersState(): FiltersStateContextValue {
  const context = useContext(FiltersStateContext)
  if (context === null) {
    throw new Error('useFiltersState must be used within a FiltersStateProvider')
  }
  return context
}
